import { NavLink } from 'react-router-dom';
import { IconAdmin, IconChat, IconMemory, IconSettings, IconSpaces } from '../components/icons';
import { zh } from '../i18n';
import { useStreamState } from '../stream/StreamProvider';
import { selectPendingApprovalCount } from '../stream/streamReducer';
import { useSession } from './SessionProvider';

/**
 * 對話 · 記憶 · 空間 · 設定 (+管理 for admins) — SPEC §10. Bottom bar on a phone,
 * left rail from 1024 px up; the swap is pure CSS (`app.css`), so there is one
 * DOM order and one focus order at every width.
 *
 * `NavLink` sets `aria-current="page"` on the active item, which is both the
 * accessible state and the styling hook — they cannot drift apart.
 */
export function BottomTabs(): JSX.Element {
  const { isAdmin } = useSession();
  const pendingApprovals = selectPendingApprovalCount(useStreamState());

  const items = [
    { to: '/', label: zh.tabs.chat, Icon: IconChat, badge: pendingApprovals > 0 },
    { to: '/memory', label: zh.tabs.memory, Icon: IconMemory, badge: false },
    { to: '/spaces', label: zh.tabs.spaces, Icon: IconSpaces, badge: false },
    { to: '/settings', label: zh.tabs.settings, Icon: IconSettings, badge: false },
    ...(isAdmin ? [{ to: '/admin', label: zh.tabs.admin, Icon: IconAdmin, badge: false }] : []),
  ];

  return (
    <nav className="tabs" aria-label={zh.tabs.navLabel}>
      {items.map(({ to, label, Icon, badge }) => (
        <NavLink key={to} to={to} end={to === '/'} className="tabs__item">
          <Icon className="tabs__icon" />
          <span>{label}</span>
          {badge ? (
            <span className="tabs__badge">
              <span className="sr-only">{zh.approval.pendingCount(pendingApprovals)}</span>
            </span>
          ) : null}
        </NavLink>
      ))}
    </nav>
  );
}
